import React from "react";
import "./Education.css";
import CardContains from "../CardContains";
export default function Education() {
  return (
    <div className="education-card">
      <CardContains
        InstitutionName={"Techno International, New Town"}
        DegreeDetails={"B-Tech in Computer Science 2019-2023 Grade: 8.95 "}
        Year={" 2019 - 2023 "}
      />
      <CardContains
        InstitutionName={"Bhavans N.S.C.B.V , Haldia"}
        DegreeDetails={"PCM with Computer Science Grad May 2019 Per: 85.2%"}
        Year={" 2018 - 2019 "}
      />
      <CardContains
        InstitutionName={"Bhavans N.S.C.B.V , Haldia"}
        DegreeDetails={" Grad. May 2017 |CGPA:10"}
        Year={" 2016 - 2017 "}
      />
    </div>
  );
}
